// ========================================
// ================== V3 ==================
// ========================================

import * as aTypes from "./actionTypes";

// ============ MY USERS  ============
export const initFetchTasks = (activeUser = null) => {
  return {
    type: aTypes.V3_TASKS_INIT,
    activeUser: activeUser,
  };
};

export const fetchTasksSuccess = (tasks) => {
  console.log("Fetching tasks success:", tasks);
  return {
    type: aTypes.V3_TASKS_SET,
    tasks: tasks,
  };
};

export const fetchTasksFail = (error) => {
  return {
    type: aTypes.V3_TASKS_FETCH_FAIL,
    error: error,
  };
};

export const resetTasks = () => {
  return {
    type: aTypes.V3_TASKS_RESET,
  };
}
